import React from 'react'
import './AppsProperties.scss'

import Heading from '../../../components/heading'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import Slider from 'react-slick'


const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: false,
    // centerMode: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
    ],
};

export default function AppsProperties({object}) {
    return (
        <div className="apps__properties">
            <Container block={"true"}>
                <Heading title="خصائص التطبيق" />
            </Container>
            <div className="apps__properties--slider">
                <Slider {...settings}>
                    {object.map((item, index) => (
                        <div key={index} className="apps__properties--item">

                            <div className="apps__properties--item--head">
                                <p className="apps__properties--item--number">{index+1}</p>
                                <h3 className="apps__properties--item--title" dangerouslySetInnerHTML={{__html: item.title}}></h3>
                            </div>
                            <ul className="apps__properties--item--content list-unstyled">
                                {item.content.map((item, index) => (
                                    <li key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}